import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
   Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate } from "../../../Utils/DateAndTime";

// when edit call the api  

function ClientForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchClientData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/clients/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          client_name: data.client_name || "",
          client_short_name: data.client_short_name || "",
          client_code: data.client_code || "",
          website: data.website || "",
          client_since: formatDate(data.client_since) || "",
          country_id: data.country_id || "",
          state_id: data.state_id || "",
          city_id: data.city_id || "",
          address: data.address || "",
          pincode: data.pincode || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch client data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchClientData();
    }
  }, [mode, id]);


  // console.log("org here is : ", org);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    client_name: "",
    client_short_name: "",
    client_code: "",
    website: "",
    client_since: "",
    country_id: "",
    state_id: "",
    city_id: "",
    address: "",
    pincode: ""
  });

  console.log("formData is :", formData);


  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};
    const pinRegex = /^[0-9]{4,10}$/;

    if (!formData.client_name?.trim()) errors.client_name = "Client name is required";
    if (formData.client_name?.trim() && formData.client_name?.trim()?.length > 100) errors.client_name = "Client Name Should be of 20 Characters only";
    if (formData.client_short_name?.trim() && formData.client_short_name?.trim().length > 20) errors.client_short_name = "Client Short Name Should be of 20 Characters only";
    if (formData.website && formData.website.length > 150) errors.website = "max 150 characters allowed";
    if (!formData.client_since) {
      errors.client_since = "Client since date is required";
    } else {
      const selectedDate = new Date(formData.client_since);
      const today = new Date();
      // Zero out time to compare date-only
      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (selectedDate > today) {
        errors.client_since = "Client since date cannot be in the future";
      }
    }

    if (!formData.country_id) errors.country_id = "Country is required";
    if (!formData.state_id) errors.state_id = "State is required";
    if (!formData.city_id) errors.city_id = "City is required";

    if (formData.pincode?.trim() && !pinRegex.test(formData.pincode)) {
      errors.pincode = "Pincode must be 4 to 10 digits";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const [selectOptions, setSelectOptions] = useState({
    Countries: [],
    States: [],
    Cities: [],
  })

  console.log("selectOptions ar e: ", selectOptions);
const countries =
  selectOptions?.Countries
    ?.slice()
    ?.sort((a, b) => a.country_name.localeCompare(b.country_name)) || [];

    const states =
  selectOptions?.States
    ?.slice()
    ?.sort((a, b) => a.state_name.localeCompare(b.state_name)) || [];

    const cities =
  selectOptions?.Cities
    ?.slice()
    ?.sort((a, b) => a.city_name.localeCompare(b.city_name)) || [];

  const fetchCountries = async () => {
    try {
      const res = await axios.get(`${MAIN_URL}/api/general/countries/v1`);
      setSelectOptions((prev) => ({ ...prev, Countries: res.data.data }));
    } catch (e) {
      console.error("Failed to load countries");
    }
  };

  const fetchStates = async (countryId) => {
    try {
      const res = await axios.get(`${MAIN_URL}/api/general/countries/${countryId}/states/v1`);
      setSelectOptions((prev) => ({ ...prev, States: res.data.data }));
    } catch (e) {
      console.error("Failed to load states");
    }
  };

  const fetchCities = async (countryId, stateId) => {
    try {
      const res = await axios.get(`${MAIN_URL}/api/general/countries/${countryId}/states/${stateId}/cities`);
      setSelectOptions((prev) => ({ ...prev, Cities: res.data.data }));
    } catch (e) {
      console.error("Failed to load cities");
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (formData?.country_id) {
      fetchStates(formData?.country_id);
    }
  }, [formData?.country_id]);

  useEffect(() => {
    if (formData?.country_id && formData?.state_id) {
      fetchCities(formData?.country_id, formData?.state_id);
    }
  }, [formData?.state_id]);


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/clients/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Client updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/clients`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Client added");
      }

      navigate("/client");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    if (mode == "add") {
      setFormData((prev) => ({
        ...prev,
        country_id: 104,
        state_id: 1077
      }));

    }
  }, [mode])

  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Client"}
        addMessage={"Client"}
        homeLink={"/client"}
        homeText={"Client"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <TextField
                  fullWidth
                  name="client_name"
                  label="Client Name *"
                  value={formData?.client_name || ""}
                  onChange={handleChange}
                  error={!!formErrors?.client_name}
                  helperText={formErrors?.client_name}
                />

                <TextField
                  fullWidth
                  name="client_short_name"
                  label="Client Short Name "
                  value={formData?.client_short_name || ""}
                  onChange={handleChange}
                  error={!!formErrors?.client_short_name}
                  helperText={formErrors?.client_short_name}
                />

                <TextField
                  fullWidth
                  name="client_code"
                  label="Client Code "
                  value={formData?.client_code || ""}
                  onChange={handleChange}
                  error={!!formErrors?.client_code}
                  helperText={formErrors?.client_code}
                />

                <TextField
                  fullWidth
                  name="website"
                  label="Website "
                  value={formData?.website || ""}
                  onChange={handleChange}
                  error={!!formErrors?.website}
                  helperText={formErrors?.website}
                />

                <TextField
                  fullWidth
                  type="date"

                  name="client_since"
                  label="Client Since *"
                  value={formData?.client_since || ""}
                  onChange={handleChange}
                  error={!!formErrors?.client_since}
                  helperText={formErrors?.client_since}
                  InputLabelProps={{ shrink: true }}
                />

                



<Autocomplete
  fullWidth
  options={countries}
  getOptionLabel={(option) => option.country_name}
  value={
    countries.find(
      (c) => c.general_country_id === formData?.country_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      country_id: newValue ? newValue.general_country_id : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Country *"
      error={!!formErrors?.country_id}
      helperText={formErrors?.country_id}
    />
  )}
/>


                



<Autocomplete
  fullWidth
  options={states}
  getOptionLabel={(option) => option.state_name}
  value={
    states.find(
      (s) => s.general_state_id === formData?.state_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      state_id: newValue ? newValue.general_state_id : "",
    }));
  }}
  disabled={!formData?.country_id}
  renderInput={(params) => (
    <TextField
      {...params}
      label="State *"
      error={!!formErrors?.state_id}
      helperText={formErrors?.state_id}
    />
  )}
/>



<Autocomplete
  fullWidth
  options={cities}
  getOptionLabel={(option) => option.city_name}
  value={
    cities.find(
      (c) => c.general_city_id === formData?.city_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      city_id: newValue ? newValue.general_city_id : "",
    }));
  }}
  disabled={!formData?.state_id}
  renderInput={(params) => (
    <TextField
      {...params}
      label="City *"
      error={!!formErrors?.city_id}
      helperText={formErrors?.city_id}
    />
  )}
/>



                <TextField
                  fullWidth
                  name="pincode"
                  label="Pincode "
                  value={formData?.pincode || ""}
                  onChange={handleChange}
                  error={!!formErrors?.pincode}
                  helperText={formErrors?.pincode}
                />

                <TextField
                  fullWidth
                  name="address"
                  label="Address "
                  value={formData?.address || ""}
                  onChange={handleChange}
                  error={!!formErrors?.address}
                  helperText={formErrors?.address}
                  multiline
                  rows={3}
                />


              </Grid>



              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ClientForm